var map = {
	"./dg-gallery-01.jpg": 5208,
	"./dg-gallery-02.jpg": 576,
	"./dg-gallery-03.jpg": 3221,
	"./dg-gallery-04.jpg": 8634,
	"./digital-gallery-01.jpg": 5186,
	"./digital-gallery-02.jpg": 5267,
	"./foodie.jpg": 2170,
	"./gallery-01.jpg": 899,
	"./gallery-02.jpg": 5870,
	"./gallery-03.jpg": 5901,
	"./gallery-04.jpg": 7983,
	"./gallery-05.jpg": 4816,
	"./gallery-06.jpg": 7756,
	"./gallery-big-01.jpg": 5304,
	"./gallery-big-02.jpg": 3251,
	"./gallery-big-03.jpg": 4403,
	"./gallery-big-04.jpg": 132,
	"./gallery-big-05.jpg": 6988,
	"./gallery-big-06.jpg": 2328,
	"./gallery2-01.jpg": 5078,
	"./gallery2-02.jpg": 8606,
	"./gallery2-03.jpg": 6874
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8379;